<div class="p20 bg-white">
  <div [innerHTML]="message" style="white-space: pre-line; word-break: break-word"></div>
  <cs-button [class]='"primary w100 btn-xs mT20"' (callback)="submitQuery()" [loading]="inProcess"><cs-button-text i18n="@@submit">Submit</cs-button-text></cs-button>
</div>